import { listTemplate } from "api";
import { Error } from "utils/Response";
import { ActionTypes } from "./types";

export const ListTemplate = payload => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data } = await listTemplate(payload?.is_allocator);

    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
